module.exports = __webpack_public_path__ + "img/logo_agios_pharmaceuticals.ffa7a410.png";